import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from './images/about_banner_btn.png';
var _hoisted_1 = {
  class: "swiper_box"
};
var _hoisted_2 = {
  class: "swiper_text_box_aboutUs"
};

var _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "swiper_text_aboutUs"
}, "向元新生", -1);

var _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "swiper_text_aboutUs"
}, "羿护未来", -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_BannerSwiper = _resolveComponent("BannerSwiper");

  var _component_CompanyIntro = _resolveComponent("CompanyIntro");

  var _component_Founder = _resolveComponent("Founder");

  var _component_Advantage = _resolveComponent("Advantage");

  var _component_TeamList = _resolveComponent("TeamList");

  var _component_Invest = _resolveComponent("Invest");

  var _component_ContactUs = _resolveComponent("ContactUs");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_BannerSwiper, {
    bannerList: $setup.bannerList
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
        src: _imports_0,
        class: "jump_detail_btn",
        onClick: _cache[0] || (_cache[0] = function () {
          return _ctx.jumpAboutUs && _ctx.jumpAboutUs.apply(_ctx, arguments);
        })
      }), _hoisted_3, _hoisted_4])];
    }),
    _: 1
  }, 8, ["bannerList"]), _createVNode(_component_CompanyIntro, {
    id: "aboutUs"
  }), _createVNode(_component_Founder), _createVNode(_component_Advantage, {
    id: "advantage"
  }), _createVNode(_component_TeamList, {
    id: "teamList"
  }), _createVNode(_component_Invest, {
    id: "invest"
  }), _createVNode(_component_ContactUs)]);
}